import React from "react";
import Select from "../form/select/Select";
import { t } from "i18next";

const LimitSelect = ({
  value = 10,
  allValue,
  limitClass,
  onChange = () => {},
}) => {
  return (
    <Select
      selectedValue={value}
      dropdownClass={"!w-full"}
      xPlacement={""}
      dropdownData={[
        allValue && {
          name: `All ${t("Items")}`,
          value: allValue,
        },
        { name: `10 ${t("Items")}`, value: 10 },
        { name: `25 ${t("Items")}`, value: 25 },
        { name: `50 ${t("Items")}`, value: 50 },
        { name: `100 ${t("Items")}`, value: 100 },
      ]?.filter(Boolean)}
      onChange={(val) => {
        onChange(val);
      }}
      dropdownButtonClass={limitClass}
    />
  );
};

export default LimitSelect;
